import { Minus } from 'lucide-react'
import { desktop } from '@/lib/printTransport'

/**
 * A minimize control for the desktop (Electron) shell, which runs fullscreen /
 * kiosk in production and otherwise gives staff no way to reach the desktop.
 * Renders ONLY inside the desktop app (feature-detected via window.bhookly) —
 * in a plain browser (incl. the Chrome --kiosk setup) it renders nothing,
 * because a web page cannot minimize the OS window; there, use Win+D.
 * Docked flush to the TOP-LEFT corner, styled as window chrome (square outer
 * edges, one rounded inner corner) rather than a floating pill.
 *
 * Not top-right: that corner belongs to the checkout rail's "Close this order"
 * × (`TicketHeader`) and to the sticky header actions on the dashboard/kitchen
 * views — all frequently used, and this button was covering them. Top-left is
 * the only screen corner whose occupant is non-interactive (the AdminSidebar
 * tenant logo); minimize is a rare escape hatch, so it yields to the controls
 * staff actually press. Below `md` it drops under the 56px mobile admin header
 * so it never lands on the nav-drawer hamburger.
 *
 * Both offsets also add `--desktop-update-banner-h` so this yields to the
 * update strip (F-FE-N47) instead of sitting on top of it — this control is
 * z-[9999] and would win. The variable is 0px whenever no update is pending, so
 * the normal case is still flush to the corner.
 */
export function DesktopMinimizeButton() {
  const bridge = desktop()
  if (!bridge) return null

  return (
    <button
      type="button"
      aria-label="Minimize window"
      title="Minimize"
      onClick={() => {
        void bridge.minimize()
      }}
      className="fixed left-0 top-[calc(3.5rem_+_var(--desktop-update-banner-h))] z-[9999] flex h-7 w-9 items-center justify-center rounded-br-md border-b border-r border-border/60 bg-background/70 text-muted-foreground shadow-sm backdrop-blur transition-colors hover:bg-muted hover:text-foreground md:top-[var(--desktop-update-banner-h)]"
    >
      <Minus className="h-4 w-4" />
    </button>
  )
}
